module.exports = __webpack_public_path__ + "static/media/logo.20d93705.png";